import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const containerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  zIndex: -1,
  pointerEvents: 'none',
};

const DynamicBackground = ({ color }) => {
  // color prop'u bir dizi, örn: ['#ff9a9e', '#fecfef']
  const gradient = `linear-gradient(135deg, ${color.join(', ')})`;

  // backgroundImage'ı animate etmek her karede tüm ekranı yeniden boyatıyordu.
  // Bunun yerine katmanları üst üste koyup opacity ile geçiyoruz; opacity
  // GPU'da compose edildiği için kaydırma akıcı kalıyor.
  return (
    <div style={containerStyle}>
      <AnimatePresence initial={false}>
        <motion.div
          key={gradient}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: gradient,
            willChange: 'opacity',
          }}
        />
      </AnimatePresence>
    </div>
  );
};

export default DynamicBackground;